import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'
import InlineEdit from '@/ui/Input/Content'

import iWebinar from '@/media/icon-webinar.png'
import iBrochure from '@/media/icon-brochure.png'
import iDownload from '@/media/icon-download.png'
import iEvent from '@/media/icon-event.png'
import iInfo from '@/media/icon-info.png'
import iPlay from '@/media/icon-play.png'
import { HEADER as HeaderText, NOITEMS as NoInfothekItems } from '@/state/types/defaultLabel'

class Infothek extends Component {
  static displayName = 'Card / Infothek + Icons'
  static propTypes = {
    item: PropTypes.object.isRequired,
  }

  render() {
    const { item, onChange, theme } = this.props
    return (
      <div className={classNames(theme, 'renderpreview', 'infothek-preview')}>
        <InlineEdit
          tagName="h1"
          key="header"
          textual
          selectText={HeaderText}
          html={item.header || HeaderText}
          onChange={(e, value) => onChange(item, 'header', value)}
        />
        <Choose>
          <When condition={this.props.item.data && this.props.item.data.length}>
            <For each="item" index="indx" of={this.props.item.data}>
              <If condition={item.linkurl && item.linktext}>
                <div key={indx}>
                  <a href={item.linkurl}>
                    <Choose>
                      <When condition={item.linktype === 'webinar'}>
                        <img
                          src={iWebinar}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </When>
                      <When condition={item.linktype === 'brochure'}>
                        <img
                          src={iBrochure}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </When>
                      <When condition={item.linktype === 'download'}>
                        <img
                          src={iDownload}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </When>
                      <When condition={item.linktype === 'event'}>
                        <img
                          src={iEvent}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </When>
                      <When condition={item.linktype === 'info'}>
                        <img
                          src={iInfo}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </When>
                      <Otherwise>
                        <img
                          src={iPlay}
                          alt=""
                          style={{ width: '1em', height: '1em', marginRight: '.5em' }}
                        />
                      </Otherwise>
                    </Choose>
                    {item.linktext}
                  </a>
                </div>
              </If>
            </For>
          </When>
          <Otherwise>
            <p className={theme['no-items']} key="warning">
              {NoInfothekItems}
            </p>
          </Otherwise>
        </Choose>
      </div>
    )
  }
}

export default Infothek



// WEBPACK FOOTER //
// ./ui/Blocks/InfothekIcons.js